<template>
  <div>
    <div class="titleSection">
      <div class="d-flex align-items-center">
        <div style="background: #CFAD6C;border-radius: 50px;width: 9px; height: 2px;margin-left: 1px"></div>
        <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-left: 3px"></div>
        <div class="headerStyle">جزییات سفارش</div>
        <div style="background: #CFAD6C;border-radius: 50px;width: 27px; height: 2px;margin-right: 3px"></div>
        <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-right: 1px"></div>
      </div>
      <img src="@/assets/images/printer.svg" alt="printer" class="printerStyle" @click="$router.push({ path: `/printinvoice/print/${route.params.id}` })" />
    </div>
    <div class="dataSection">
      <div class="orderGrid">
        <div class="detail">
          <div class="rightContent">کد سفارش :</div>
          <div class="leftContent">{{ route.params.id }}</div>
        </div>
        <div class="detail">
          <div class="rightContent">تعداد کالا :</div>
          <div class="leftContent">{{ detailData.productsTotalCount }}</div>
        </div>
        <div class="detail">
          <div class="rightContent">تاریخ ثبت سفارش :</div>
          <div class="leftContent">{{ convertJustDate(detailData.invoiceDate) }}</div>
        </div>
        <div class="detail">
          <div class="rightContent">سفارش دهنده :</div>
          <div class="leftContent">{{ detailData.buyer.firstName }} {{ detailData.buyer.lastName }}</div>
        </div>
        <div class="detail">
          <div class="rightContent">شماره تماس :</div>
          <div class="leftContent">{{ detailData.buyer.phoneNumber }}</div>
        </div>
        <div class="detail"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detailData: {
      default: null,
    },
  },
  computed: {
    route() {
      return this.$route
    },
  },
}
</script>

<style scoped lang="scss">
.titleSection {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerStyle {
  color: #414141;
  font-size: 18px;
}
.printerStyle {
  cursor: pointer;
  width: 30px;
  height: 30px;
}
.dataSection {
  background: rgba(245, 245, 245, 0.6);
  border-radius: 8px;
  padding: 0 20px;
}
.orderGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 70px);
  grid-row-gap: 2px;
  background: repeating-linear-gradient(to bottom, transparent 0, transparent 70px, #c4c4c4 72px, #c4c4c4 71px);
}
.detail {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rightContent {
  font-size: 16px;
  color: #979797;
  margin-left: 5px;
}
.leftContent {
  font-size: 16px;
  color: #4a4a4a;
}
@media only screen and (max-width: 992px) {
  .headerStyle {
    font-size: 16px;
  }
  .printerStyle {
    width: 22px;
    height: 22px;
  }
  .orderGrid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 70px);
  }
  .detail {
    justify-content: flex-start;
  }
  .rightContent {
    font-size: 14px;
  }
  .leftContent {
    font-size: 14px;
  }
}
@media only screen and (max-width: 576px) {
  .dataSection {
    padding: 0 8px;
  }
  .headerStyle {
    font-size: 14px;
  }
  .printerStyle {
    width: 20px;
    height: 20px;
  }
  .rightContent {
    font-size: 12px;
  }
  .leftContent {
    font-size: 12px;
  }
  .detail {
    margin-top: 12px;
    flex-direction: column;
  }
}
</style>
